import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { ApiRequestConfig, ApiResponse } from './api-request-types'

type ApiRequestType = <RequestBodyT, ResponseBodyT>(config: ApiRequestConfig<RequestBodyT>) => Promise<ApiResponse<ResponseBodyT>>

/**
 * @template RequestBodyT
 * @template ResponseBodyT
 * @param {ApiRequestConfig<RequestBodyT>} config
 */
const ApiRequest: ApiRequestType = async <RequestBodyT, ResponseBodyT>(config: ApiRequestConfig<RequestBodyT>) => {
  const baseURL = process.env.REACT_APP_API_URL

  const data = typeof (config.data) === 'object' || !config.data ? config.data : JSON.stringify(config.data)

  const axiosConfig: AxiosRequestConfig = {
    method: config.method,
    url: baseURL + config.path,
    params: config.params,
    data: data,
    // responseType: config.responseType,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      Authorization: `${localStorage.getItem('token')}`,
    },
  }

  let response: AxiosResponse

  try {
    response = await axios(axiosConfig)
  } catch (error) {
    const err = error as AxiosError


    if (err.response?.data) {
      if (typeof (err.response.data) === 'string') {

        return {
          error: new Error(err.response.data || 'Er is iets misgegaan'),
          statusCode: err.response.status
        }
      }
    }

    if (err?.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'

      return {
        error: new Error('Authenticathion failed. Error: ' + err),
        statusCode: err.response.status
      }
    }

    if (err?.response?.status === 403) {
      return {
        error: new Error('U heeft geen rechten om deze actie uit te voeren'),
        statusCode: err.response.status
      }
    }

    if (!err.response) {
      return {
        error: new Error('Kan de server niet bereiken. Controleer uw internetverbinding'),
        statusCode: undefined
      }
    }

    return {
      error: new Error('Er is iets misgegaan'),
      statusCode: err.response.status
    }
  }


  return {
    data: response.data as ResponseBodyT,
    statusCode: response.status,
  }
}

export default ApiRequest
